<template>
    <div class="yq-templates-news-list" v-if="config&&data">
        <div class="yq-templates-news-list-item" v-for="row in data" :key="row.id">
            <div class="yq-templates-news-list-picture" v-if="row.source[config.coverPicture.config.field]">
                <img :src="row.source[config.coverPicture.config.field]"/>
            </div>
            <div class="yq-templates-news-list-info">
                <div>
                    <div class="yq-templates-news-list-headline" @click="showDetails(row.id)">
                        {{row.source[config.title.config.field]}}
                    </div>
                    <div class="yq-templates-news-list-summary" v-if="config.summary.config.hide==='否'">
                        {{row.source[config.summary.config.field]}}
                    </div>
                </div>
                <div class="yq-templates-news-list-foot">
                    <div>
                        <pretty-date-time :value="row.source[config.publishDate.config.field]" format="uuuu-MM-dd"
                                          :value-format="publishDateField.dateValueFormat" java-format></pretty-date-time>
                    </div>
                    <div>来自:{{row.source[config.site.config.field]}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import preview from '../../assets/images/templates/news_list.png'
    import thumbnail from '../../assets/images/templates/news_list_thumbnail.png'
    import templateUtils from '../../service/view-template-utils'

    const regions = {
        coverPicture: {
            name: '封面图',
            config: {
                field: {
                    name: '图片链接字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        title: {
            name: '标题',
            config: {
                field: {
                    name: '标题字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        summary: {
            name: '摘要',
            config: {
                field: {
                    name: '摘要字段',
                    required: false,
                    type: 'field'
                },
                hide: {
                    name: '是否隐藏',
                    required: true,
                    description: '取值范围"是"或者"否"',
                    type: 'string'
                }
            }
        },
        publishDate: {
            name: '发布时间',
            config: {
                field: {
                    name: '发布时间字段',
                    required: true,
                    type: 'field'
                }
            }
        },
        site: {
            name: '网站名称',
            config: {
                field: {
                    name: '网站名称字段',
                    required: true,
                    type: 'field'
                }
            }
        },
    }
    export default {
        name: "NewsList",
        props: {
            config: Object,
            data: Array,
            datasource: Object,
            pageNumber: {
                type: Number,
                default: 1
            },
            pageSize: {
                type: Number,
                default: 10
            }
        },
        computed: {
            publishDateField () {
                return this.datasource.fields.find(field => field.name === this.config.publishDate.config.field)
            }
        },
        methods: {
            showDetails(id) {
                this.$emit('show-details', id)
            }
        }
    }
    function getFields(config){
        const fields = []
        fields.push(config.coverPicture.config.field)
        fields.push(config.title.config.field)
        if(config.summary.config.hide==='否'){
            fields.push(config.summary.config.field)
        }
        fields.push(config.publishDate.config.field)
        fields.push(config.site.config.field)
        return fields
    }
    function validateConfig(config){
        return templateUtils.validateConfig(regions, config)
    }
    export {regions, preview, thumbnail, getFields, validateConfig}
</script>

<style scoped>

</style>
